import React from 'react'
import {connect} from 'react-redux'
import styles from './GuideBlock.scss'
import {SectionBox} from 'common/styleguide/SectionBox'
import {GuidePageListItem} from '../../GuidePage/GuidesList/GuidePageListItem'
import {loadGuides} from 'lib/api/experiences/guides'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import p from 'prop-types'

export class _GuideBlock extends React.PureComponent {
  static propTypes = {
    experience: p.object.isRequired,
    loadGuides: p.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      expandedId: null
    }
  }

  componentDidMount () {
    this.props.loadGuides(this.props.experience.id)
  }

  componentDidUpdate (prevProps) {
    const {loadGuides} = this.props
    if (prevProps.experience.id !== this.props.experience.id) {
      loadGuides(this.props.experience.id)
    }
  }

  setExpanded = (id) => {
    const {expandedId} = this.state
    if (expandedId === id) {
      this.setState({expandedId: null})
    } else {
      this.setState({expandedId: id})
    }
  }

  render () {
    const {guides, guideIds, experience} = this.props
    const {expandedId} = this.state

    return (
      <div>
        <SectionBox title='Guide' noPadding>
          {guideIds && guideIds.map(id =>
            <GuidePageListItem
              key={`overviewGP-${id}`}
              editable={false}
              guide={guides.get(id)}
              setExpanded={this.setExpanded}
              expanded={expandedId === id} />
          )}
          <div className={styles.blockFooter}>
            <CTA secondary inline onClick={this.editGuidesClicked} to={`/experiences/${experience.id}/guide`}>Edit Guide</CTA>
            <CTA link inline target='print_guide' href={`/experiences/${experience.id}/print_guide`}>
              <Icon i='md-print' size={18} />
              <span style={{marginLeft: '10px'}}>Print Guide</span>
            </CTA>
          </div>
        </SectionBox>
      </div>
    )
  }
}

const mapDispatchToProps = {
  loadGuides: loadGuides
}

const mapStateToProps = (state, ownProps) => {
  const {experience} = ownProps
  const gState = state.guides

  return {
    guideIds: gState.getIn(['experienceGuides', experience.id]),
    guides: gState.getIn(['guidePages'])
  }
}

export const GuideBlock = connect(
  mapStateToProps,
  mapDispatchToProps
)(_GuideBlock)
